import { render, staticRenderFns } from "./LeaveStatus.vue?vue&type=template&id=1e8ed8c4"
import script from "./LeaveStatus.vue?vue&type=script&lang=js"
export * from "./LeaveStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports